import { NO_TRIM_VALUE } from './parser'

export const serializeTrim = (trim: string | null): string | null => {
  return trim === NO_TRIM_VALUE ? '' : trim
}
